/**
 * Action types for group configuration functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

export const GET_CLI_USERS = 'GET_CLI_USERS';
export const GET_CLI_USERS_SUCCESS = 'GET_CLI_USERS_SUCCESS';
export const GET_CLI_USERS_FAIL = 'GET_CLI_USERS_FAIL';
export const DELETE_CLI_USERS = 'DELETE_CLI_USERS';
export const DELETE_CLI_USERS_SUCCESS = 'DELETE_CLI_USERS_SUCCESS';
export const DELETE_CLI_USERS_FAIL = 'DELETE_CLI_USERS_FAIL';
export const ADD_CLI_USERS = 'ADD_CLI_USERS';
export const ADD_CLI_USERS_COMPLETE = 'ADD_CLI_USERS_COMPLETE';
export const EDIT_CLI_USERS = 'EDIT_CLI_USERS';
export const EDIT_CLI_USERS_COMPLETE = 'EDIT_CLI_USERS_COMPLETE';
export const GET_GROUP_CONFIGURATION = 'GET_GROUP_CONFIGURATION';
export const GET_GROUP_CONFIGURATION_SUCCESS =
	'GET_GROUP_CONFIGURATION_SUCCESS';
export const GET_GROUP_CONFIGURATION_FAIL = 'GET_GROUP_CONFIGURATION_FAIL';
export const UPDATE_GROUP_CONFIGURATION = 'UPDATE_GROUP_CONFIGURATION';
export const UPDATE_GROUP_CONFIGURATION_COMPLETE =
	'UPDATE_GROUP_CONFIGURATION_COMPLETE';
export const UPDATE_ACCESS_POINT_NAME = 'UPDATE_ACCESS_POINT_NAME';
export const UPDATE_ACCESS_POINT_NAME_COMPLETE =
	'UPDATE_ACCESS_POINT_NAME_COMPLETE';
export const GET_AP_NAME = 'GET_AP_NAME';
export const GET_AP_NAME_SUCCESS = 'GET_AP_NAME_SUCCESS';
export const GET_AP_NAME_FAIL = 'GET_AP_NAME_FAIL';
export const GET_TIP_AP_CONFIG = 'GET_TIP_AP_CONFIG';
export const GET_TIP_AP_CONFIG_SUCCESS = 'GET_TIP_AP_CONFIG_SUCCESS';
export const GET_TIP_AP_CONFIG_FAIL = 'GET_TIP_AP_CONFIG_FAIL';
export const UPDATE_TIP_AP_CONFIG = 'UPDATE_TIP_AP_CONFIG';
export const UPDATE_TIP_AP_CONFIG_SUCCESS = 'UPDATE_TIP_AP_CONFIG_SUCCESS';
export const UPDATE_TIP_AP_CONFIG_FAIL = 'UPDATE_TIP_AP_CONFIG_FAIL';
export const RESET_TIP_ACTIONS = 'RESET_TIP_ACTIONS';
export const GET_INTERFACE_LIST = 'GET_INTERFACE_LIST';
export const GET_INTERFACE_LIST_SUCCESS = 'GET_INTERFACE_LIST_SUCCESS';
export const GET_INTERFACE_LIST_FAIL = 'GET_INTERFACE_LIST_FAIL';
export const UPDATE_TIP_CONFIG = 'UPDATE_TIP_CONFIG';
export const UPDATE_TIP_CONFIG_SUCCESS = 'UPDATE_TIP_CONFIG_SUCCESS';
export const UPDATE_TIP_CONFIG_ERROR = 'UPDATE_TIP_CONFIG_ERROR';
export const ADD_ACCESSCLI_MODAL = 'ADD_ACCESSCLI_MODAL';
export const GET_TIP_CONFIG = 'GET_TIP_CONFIG';
export const GET_TIP_CONFIG_SUCCESS = 'GET_TIP_CONFIG_SUCCESS';
export const GET_TIP_CONFIG_FAIL = 'GET_TIP_CONFIG_FAIL';
export const UPDATE_LAN_WAN_TIP_CONFIG = 'UPDATE_LAN_WAN_TIP_CONFIG';
export const UPDATE_LAN_WAN_TIP_CONFIG_SUCCESS =
	'UPDATE_LAN_WAN_TIP_CONFIG_SUCCESS';
export const UPDATE_LAN_WAN_TIP_CONFIG_FAIL = 'UPDATE_LAN_WAN_TIP_CONFIG_FAIL';
export const GET_GROUP_INFO = 'GET_GROUP_INFO';
export const GET_GROUP_INFO_SUCCESS = 'GET_GROUP_INFO_SUCCESS';
export const GET_GROUP_INFO_FAIL = 'GET_GROUP_INFO_FAIL';
export const GET_ROGUE_AP_LIST = 'GET_ROGUE_AP_LIST';
export const GET_ROGUE_AP_LIST_SUCCESS = 'GET_ROGUE_AP_LIST_SUCCESS';
export const GET_ROGUE_AP_LIST_FAIL = 'GET_ROGUE_AP_LIST_FAIL';

export const MOVE_TO_KWOWN_ROGUE = 'MOVE_TO_KWOWN_ROGUE';
export const MOVE_TO_KWOWN_ROGUE_SUCCESS = 'MOVE_TO_KWOWN_ROGUE_SUCCESS';
export const MOVE_TO_KWOWN_ROGUE_FAIL = 'MOVE_TO_KWOWN_ROGUE_FAIL';

export const DELETE_KNOWN_ROGUE = 'DELETE_KNOWN_ROGUE';
export const DELETE_KNOWN_ROGUE_SUCCESS = 'DELETE_KNOWN_ROGUE_SUCCESS';
export const DELETE_KNOWN_ROGUE_FAIL = 'DELETE_KNOWN_ROGUE_FAIL';

export const BULK_UPLOAD_KNOWN = 'BULK_UPLOAD_KNOWN';
export const BULK_UPLOAD_KNOWN_SUCCESS = 'BULK_UPLOAD_KNOWN_SUCCESS';
export const BULK_UPLOAD_KNOWN_FAIL = 'BULK_UPLOAD_KNOWN_FAIL';

export const RESET_ROGUE_AP_ACTIONS = 'RESET_ROGUE_AP_ACTIONS';

export const GET_SWITCH_TOPOLOGY = 'GET_SWITCH_TOPOLOGY';
export const GET_SWITCH_TOPOLOGY_SUCCESS = 'GET_SWITCH_TOPOLOGY_SUCCESS';
export const GET_SWITCH_TOPOLOGY_FAILURE = 'GET_SWITCH_TOPOLOGY_FAILURE';

export const ROGUE_WIFI_SCAN = 'ROGUE_WIFI_SCAN';
export const ROGUE_WIFI_SCAN_SUCCESS = 'ROGUE_WIFI_SCAN_SUCCESS';
export const ROGUE_WIFI_SCAN_FAIL = 'ROGUE_WIFI_SCAN_FAIL';

export const GET_AP_GROUP_INFO = 'GET_AP_GROUP_INFO';
export const GET_AP_GROUP_INFO_SUCCESS = 'GET_AP_GROUP_INFO_SUCCESS';
export const GET_AP_GROUP_INFO_FAIL = 'GET_AP_GROUP_INFO_FAIL';

